function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Appeler");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M15.25,4.5a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M19.75,4.5a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M19.5,8a2,2,0,0,1-4,0Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.433.5a6.059,6.059,0,0,0-5.152,9.259L10.5,13.5l3.741-1.782A6.064,6.064,0,1,0,17.433.5Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M8.612,12.813c-.637-.686-1.249-1.386-1.828-2.093l.708-.707a2,2,0,0,0,0-2.828L5.369,5.064a2,2,0,0,0-2.828,0L1.378,6.228A2.994,2.994,0,0,0,1,10,46.457,46.457,0,0,0,14,23a3,3,0,0,0,3.774-.378l1.164-1.163a2,2,0,0,0,0-2.828l-2.121-2.123a2,2,0,0,0-2.829,0l-.707.707c-.706-.579-1.407-1.191-2.094-1.828"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.e066cd81.svg";
export { ForwardRef as ReactComponent };